import styled from '@themes/theme'

export const GuestModePopupWrap = styled.div`
  position: relative; /* 아이폰에서 뒷배경이 앞에 위치하는 현상 해결 */
  margin: 29vh auto 4px;
  width: 48vw;
  max-width: 250px;
  img, svg {
    width: 100%;
    max-width: 250px;
    height: auto;
    transform: translate3d(0, 0, 0);
  }

`
